import * as React from 'react';
import { Modal, Button, Group } from '@mantine/core';
import { MapContainer, TileLayer } from 'react-leaflet'
import L from 'leaflet'
import { MapHelper } from './MapHelper';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

interface IProps {
    onClose: any;
    onSave: any;
    value: any;
}

const INITIAL_LOCATION = [47.9189, 106.9176];

const MapComponent = ({ onClose, onSave, value = [] }: IProps) => {

    const [ location, setLocation ] = React.useState(value);

    const handleOk = () => {
        if (location) {
            onSave(location);
        }
    };

    const handleClick = (event: any) => {
        const { lat, lng } = event.latlng;
        setLocation({ lat, lng });
    };

    const getMapCenter = () => {
        return value?.length ? value : INITIAL_LOCATION;
    }

    return (
        <Modal
            size='100vw'
            opened={true}
            onClose={onClose}
            title="Хаяг сонгох"
        >
            <div style={{ height: '70vh' }}>
                <MapContainer center={getMapCenter()} zoom={13} style={{ width: '100%', height: '100%' }}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <MapHelper location={location ?? []} onClick={handleClick} />
                </MapContainer>
            </div>
            <Group position="right">
                <Button onClick={handleOk} color={'color-secondary'} mt={'sm'}>
                    Хадгалах
                </Button>
            </Group>
        </Modal>
    )
}
export default MapComponent
